var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 27C17.0804 27 20.5142 25.5777 23.0459 23.0459C25.5777 20.5142 27 17.0804 27 13.5C27 9.91958 25.5777 6.4858 23.0459 3.95406C20.5142 1.42232 17.0804 0 13.5 0C9.91958 0 6.4858 1.42232 3.95406 3.95406C1.42232 6.4858 0 9.91958 0 13.5C0 17.0804 1.42232 20.5142 3.95406 23.0459C6.4858 25.5777 9.91958 27 13.5 27ZM19.4786 10.5107C19.5925 10.3588 19.6755 10.1858 19.7226 10.0018C19.7697 9.81783 19.7802 9.62634 19.7533 9.4383C19.7265 9.25026 19.6628 9.06936 19.566 8.90591C19.4693 8.74247 19.3412 8.59968 19.1893 8.48571C19.0373 8.37175 18.8644 8.28882 18.6804 8.24168C18.4964 8.19454 18.3049 8.1841 18.1169 8.21097C17.9288 8.23783 17.7479 8.30147 17.5845 8.39824C17.421 8.49502 17.2783 8.62304 17.1643 8.775L12.3795 15.1547L9.70072 12.4779C9.42652 12.2224 9.06386 12.0833 8.68914 12.0899C8.31441 12.0965 7.95688 12.2483 7.69187 12.5133C7.42686 12.7783 7.27506 13.1358 7.26845 13.5106C7.26184 13.8853 7.40093 14.2479 7.65643 14.5221L11.5136 18.3793C11.6601 18.5257 11.8363 18.639 12.0304 18.7115C12.2244 18.7839 12.4318 18.8139 12.6384 18.7992C12.845 18.7846 13.0461 18.7258 13.228 18.6267C13.4099 18.5276 13.5685 18.3906 13.6929 18.225L19.4786 10.5107Z",
    fill: "#4DAA57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.c1f6b2b7ac464303ad3a0cf3373dcccd.svg";
export { ForwardRef as ReactComponent };